import { render, staticRenderFns } from "./HelpPage.vue?vue&type=template&id=73baf365&scoped=true"
import script from "./HelpPage.vue?vue&type=script&lang=js"
export * from "./HelpPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73baf365",
  null
  
)

export default component.exports